export default {
  headlineLarge: 'Oh, No...',
  headlineSmall: 'Technischer Fehler',
  infoMessage: 'Es ist ein technischer Fehler aufgetreten. Bitte versuchen Sie es zu einem späterem Zeitpunkt erneut.',
};